/**
 * SCS Vehicle Selector — Year / Make / Model dynamic dropdowns
 * Populates makes and models from a static vehicle data map.
 * On submit, navigates to /pages/{year}-{make}-{model}-luxury-seat-covers
 */
(function () {
  'use strict';

  var vehicleData = {
    'Acura': ['CL','ILX','Integra','Legend','MDX','NSX','RDX','RL','RLX','RSX','TL','TLX','TSX','Vigor','ZDX'],
    'Audi': ['A3','A4','A5','A6','A7','A8','Allroad','e-tron','Q3','Q4','Q5','Q7','Q8','RS','S3','S4','S5','S6','S7','S8','SQ5','SQ7','SQ8','TT'],
    'BMW': ['1 Series','2 Series','3 Series','4 Series','5 Series','6 Series','7 Series','8 Series','i3','i4','i5','i7','iX','M2','M3','M4','M5','M8','X1','X2','X3','X4','X5','X6','X7','Z3','Z4'],
    'Buick': ['Cascada','Century','Enclave','Encore','Encore GX','Envision','Envista','LaCrosse','LeSabre','Lucerne','Park Avenue','Rainier','Regal','Rendezvous','Terraza','Verano'],
    'Cadillac': ['ATS','CT4','CT5','CT6','CTS','DeVille','DTS','Eldorado','Escalade','Escalade ESV','Lyriq','Seville','SRX','STS','XT4','XT5','XT6','XTS'],
    'Chevrolet': ['Avalanche','Blazer','Bolt','Camaro','Cavalier','Cobalt','Colorado','Corvette','Cruze','Equinox','Express','HHR','Impala','Lumina','Malibu','Monte Carlo','Silverado 1500','Silverado 2500','Silverado 3500','Sonic','Spark','Suburban','Tahoe','Tracker','TrailBlazer','Traverse','Trax','Uplander','Venture'],
    'Chrysler': ['200','300','300M','Aspen','Concorde','Crossfire','LHS','Pacifica','PT Cruiser','Sebring','Town & Country','Voyager'],
    'Dodge': ['Avenger','Caliber','Caravan','Challenger','Charger','Dakota','Dart','Durango','Grand Caravan','Hornet','Intrepid','Journey','Magnum','Neon','Nitro','Ram 1500','Ram 2500','Ram 3500','Stratus','Viper'],
    'Ford': ['Bronco','Bronco Sport','C-Max','Crown Victoria','E-150','E-250','E-350','EcoSport','Edge','Escape','Excursion','Expedition','Explorer','F-150','F-250','F-350','Fiesta','Five Hundred','Flex','Focus','Freestar','Freestyle','Fusion','Maverick','Mustang','Mustang Mach-E','Ranger','Taurus','Thunderbird','Transit','Windstar'],
    'Genesis': ['G70','G80','G90','GV60','GV70','GV80'],
    'GMC': ['Acadia','Canyon','Envoy','Hummer EV','Jimmy','Safari','Savana','Sierra 1500','Sierra 2500','Sierra 3500','Sonoma','Terrain','Yukon','Yukon XL'],
    'Honda': ['Accord','Civic','Clarity','CR-V','CR-Z','Crosstour','Element','Fit','HR-V','Insight','Odyssey','Passport','Pilot','Prelude','Prologue','Ridgeline','S2000'],
    'Hyundai': ['Accent','Azera','Elantra','Entourage','Genesis','Ioniq','Ioniq 5','Ioniq 6','Kona','Nexo','Palisade','Santa Cruz','Santa Fe','Sonata','Tiburon','Tucson','Veloster','Venue','Veracruz','XG350'],
    'Infiniti': ['EX','FX','G25','G35','G37','I30','I35','JX','M35','M37','M45','M56','Q40','Q50','Q60','Q70','QX30','QX50','QX55','QX56','QX60','QX70','QX80'],
    'Jaguar': ['E-Pace','F-Pace','F-Type','I-Pace','S-Type','X-Type','XE','XF','XJ','XK'],
    'Jeep': ['Cherokee','Commander','Compass','Gladiator','Grand Cherokee','Grand Cherokee L','Grand Wagoneer','Liberty','Patriot','Renegade','Wagoneer','Wrangler'],
    'Kia': ['Borrego','Cadenza','Carnival','EV6','EV9','Forte','K5','K900','Niro','Optima','Rio','Sedona','Seltos','Sorento','Soul','Spectra','Sportage','Stinger','Telluride'],
    'Land Rover': ['Defender','Discovery','Discovery Sport','Freelander','LR2','LR3','LR4','Range Rover','Range Rover Evoque','Range Rover Sport','Range Rover Velar'],
    'Lexus': ['CT','ES','GS','GX','IS','LC','LFA','LS','LX','NX','RC','RX','RZ','SC','TX','UX'],
    'Lincoln': ['Aviator','Continental','Corsair','LS','MKC','MKS','MKT','MKX','MKZ','Nautilus','Navigator','Town Car','Zephyr'],
    'Maserati': ['Ghibli','GranTurismo','Grecale','Levante','Quattroporte'],
    'Mazda': ['3','5','6','CX-3','CX-30','CX-5','CX-50','CX-7','CX-9','CX-90','Mazda2','Mazda3','Mazda5','Mazda6','MX-5 Miata','MX-30','RX-8','Tribute'],
    'Mercedes-Benz': ['A-Class','AMG GT','B-Class','C-Class','CL-Class','CLA','CLK','CLS','E-Class','EQB','EQE','EQS','G-Class','GLA','GLB','GLC','GLE','GLK','GLS','Metris','R-Class','S-Class','SL','SLC','SLK','Sprinter'],
    'Mini': ['Clubman','Convertible','Countryman','Coupe','Hardtop','Paceman'],
    'Mitsubishi': ['Eclipse','Eclipse Cross','Endeavor','Galant','Lancer','Mirage','Outlander','Outlander Sport','Raider'],
    'Nissan': ['350Z','370Z','Altima','Armada','Frontier','Juke','Kicks','Leaf','Maxima','Murano','Pathfinder','Quest','Rogue','Rogue Sport','Sentra','Titan','Titan XD','Versa','Xterra','Z'],
    'Pontiac': ['Aztek','Bonneville','G5','G6','G8','Grand Am','Grand Prix','GTO','Montana','Solstice','Sunfire','Torrent','Vibe'],
    'Ram': ['1500','2500','3500','ProMaster','ProMaster City'],
    'Saab': ['9-2X','9-3','9-5','9-7X'],
    'Saturn': ['Astra','Aura','Ion','L-Series','Outlook','Relay','S-Series','Sky','Vue'],
    'Subaru': ['Ascent','BRZ','Crosstrek','Forester','Impreza','Legacy','Outback','Solterra','WRX','XV Crosstrek'],
    'Toyota': ['4Runner','86','Avalon','C-HR','Camry','Celica','Corolla','Corolla Cross','Crown','FJ Cruiser','GR86','Grand Highlander','Highlander','Land Cruiser','Matrix','Mirai','Prius','RAV4','Sequoia','Sienna','Solara','Supra','Tacoma','Tundra','Venza','Yaris'],
    'Volkswagen': ['Arteon','Atlas','Atlas Cross Sport','Beetle','CC','e-Golf','Eos','GLI','Golf','Golf GTI','Golf R','ID.4','ID.Buzz','Jetta','Passat','Phaeton','Rabbit','Routan','Taos','Tiguan','Touareg'],
    'Volvo': ['C30','C40','C70','EX30','EX90','S40','S60','S70','S80','S90','V40','V50','V60','V70','V90','XC40','XC60','XC70','XC90']
  };

  var makes = Object.keys(vehicleData).sort();

  function slugify(str) {
    return str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
  }

  function clearSelect(selectEl, placeholder) {
    while (selectEl.options.length > 0) {
      selectEl.remove(0);
    }
    var opt = document.createElement('option');
    opt.value = '';
    opt.textContent = placeholder;
    selectEl.appendChild(opt);
  }

  function populateSelect(selectEl, options, placeholder) {
    clearSelect(selectEl, placeholder);
    for (var i = 0; i < options.length; i++) {
      var o = document.createElement('option');
      o.value = options[i];
      o.textContent = options[i];
      selectEl.appendChild(o);
    }
  }

  function navigateToVehicle(year, make, model) {
    if (year && make && model) {
      /* Save to sessionStorage for PDP page to read */
      sessionStorage.setItem('user_year', year);
      sessionStorage.setItem('user_make', make);
      sessionStorage.setItem('user_model', model);
      sessionStorage.setItem('user_compat', 'true');
      /* Redirect to Spring Refresh Deal with vehicle params + anchor to vehicle section */
      var url = '/pages/love-your-ride-deal?user_year=' + encodeURIComponent(year) +
        '&user_make=' + encodeURIComponent(make) +
        '&user_model=' + encodeURIComponent(model) +
        '&user_compat=true#scs-step-1';
      window.location.href = url;
    }
  }

  function initDesktop() {
    var yearEl = document.getElementById('year-input');
    var makeEl = document.getElementById('make-input');
    var modelEl = document.getElementById('model-input');
    var submitBtn = document.getElementById('vehicle-submit-button');
    if (!yearEl || !makeEl || !modelEl || !submitBtn) return;

    yearEl.addEventListener('change', function () {
      if (this.value) {
        populateSelect(makeEl, makes, 'Make');
        makeEl.disabled = false;
      } else {
        clearSelect(makeEl, 'Make');
        makeEl.disabled = true;
      }
      clearSelect(modelEl, 'Model');
      modelEl.disabled = true;
      submitBtn.disabled = true;
    });

    makeEl.addEventListener('change', function () {
      if (this.value && vehicleData[this.value]) {
        populateSelect(modelEl, vehicleData[this.value], 'Model');
        modelEl.disabled = false;
      } else {
        clearSelect(modelEl, 'Model');
        modelEl.disabled = true;
      }
      submitBtn.disabled = true;
    });

    modelEl.addEventListener('change', function () {
      submitBtn.disabled = !this.value;
    });

    submitBtn.addEventListener('click', function (e) {
      e.preventDefault();
      navigateToVehicle(yearEl.value, makeEl.value, modelEl.value);
    });
  }

  function initMobile() {
    var makeElM = document.getElementById('make-input-mobile');
    var modelElM = document.getElementById('model-input-mobile');
    var yearElM = document.getElementById('year-input-mobile');
    var submitBtn = document.getElementById('vehicle-submit-button');
    if (!makeElM || !modelElM || !yearElM) return;

    populateSelect(makeElM, makes, 'Make');
    makeElM.disabled = false;

    makeElM.addEventListener('change', function () {
      if (this.value && vehicleData[this.value]) {
        populateSelect(modelElM, vehicleData[this.value], 'Model');
        modelElM.disabled = false;
      } else {
        clearSelect(modelElM, 'Model');
        modelElM.disabled = true;
      }
      clearSelect(yearElM, 'Year');
      yearElM.disabled = true;
      if (submitBtn) submitBtn.disabled = true;
    });

    modelElM.addEventListener('change', function () {
      if (this.value) {
        yearElM.disabled = false;
      } else {
        yearElM.disabled = true;
      }
      if (submitBtn) submitBtn.disabled = true;
    });

    yearElM.addEventListener('change', function () {
      if (submitBtn) submitBtn.disabled = !this.value;
    });
  }

  function init() {
    initDesktop();
    initMobile();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
